import React from 'react';
import { Route, Router } from 'react-router';
import { Provider } from 'react-redux';
import { unauthenticatedStore, authenticatedStore } from './app-store';
import history from './app-history';
import AppCIPRedirect from './app-redirect-cip';
import AppSecureAuthRedirect from './app-secureauth-redirect';
import ErrorPage from './views/error/error';
import AuthorableContent from './authorable-content/authorable-content';
import DataBootStrap from './components/data-bootstrap/data-bootstrap';
import Vantage from './views/vantage/vantage';
import { getEventRouteAndUserHashDetails, checkHtmlInPathName } from './app-actions';
import HostedMigration from './views/hosted-migration/hosted-migration';
import BusinessPopMail from './views/business-pop-mail/business-pop-mail';
import AuthenticatedRoot from './components/authenticated-root/authenticated-root';
import AdaptiveMobilityExternal from './views/adaptive-mobility-external/adaptive-mobility-external';

import { APP_CONFIG, ROUTE_PATHS, WINDOW_START_POSITION, DEBUG_MODE } from './app-constants';

const eventRouteDetails = getEventRouteAndUserHashDetails();
console.log(eventRouteDetails);

// only for purl Based apps on dev/stage/prod
if (eventRouteDetails.isEventRouteAndUserHashPresent
  || eventRouteDetails.isHostedRoutePresent
  || eventRouteDetails.isBusinessPopMailRoutePresent
  || eventRouteDetails.isAdaptiveMobilityExternalPresent) {
  if (window.location.origin.search('localhost') === -1 && checkHtmlInPathName() === false) {
    const newHtmlPath = window.location.pathname.replace('.htm', '.html');
    const purlAppHtmlFullPath = `${window.location.origin}${newHtmlPath}${window.location.hash}`;
    if (DEBUG_MODE) {
      console.log('purl app with .htm'); // eslint-disable-line
      console.log(newHtmlPath); // eslint-disable-line
      console.log(purlAppHtmlFullPath); // eslint-disable-line
    }
    window.location = purlAppHtmlFullPath;
  }
}

if (eventRouteDetails.isEventRouteAndUserHashPresent
  || eventRouteDetails.isHostedRoutePresent
  || eventRouteDetails.isBusinessPopMailRoutePresent
  || eventRouteDetails.isAdaptiveMobilityExternalPresent) {
  window.tcom.researchInsights.appConfig.purlApp = true;
}

const { homepage, error, vantage, hostedMigration, businessPopMail, adaptiveMobilityExternal, partnerView } = ROUTE_PATHS;

history.listen(() => {
  window.scrollTo(WINDOW_START_POSITION, WINDOW_START_POSITION);
});

sessionStorage.clear();

const VantageAndHostedMigrationRoutesSetup = () => (
  <DataBootStrap
    vantage={eventRouteDetails.isEventRouteAndUserHashPresent}
    hostedMigration={eventRouteDetails.isHostedRoutePresent}
    businessPopMail={eventRouteDetails.isBusinessPopMailRoutePresent}
    adaptiveMobilityExternal={eventRouteDetails.isAdaptiveMobilityExternalPresent}
  >
    <Router history={history}>
      <React.Fragment>
        <Route path={`${APP_CONFIG.reactBasePath + error.route}`} component={ErrorPage} />
        <Route exact path={`${APP_CONFIG.reactBasePath + vantage.route}`} component={Vantage} />
        <Route exact path={`${APP_CONFIG.reactBasePath + hostedMigration.route}`} component={HostedMigration} />
        <Route exact path={`${APP_CONFIG.reactBasePath + businessPopMail.route}`} component={BusinessPopMail} />
        <Route exact path={`${APP_CONFIG.reactBasePath + adaptiveMobilityExternal.route}`} component={AdaptiveMobilityExternal} />
      </React.Fragment>
    </Router>
  </DataBootStrap>
);

const SSMRoutesSetup = () => {
  if (window === window.parent) {
    return (
      <DataBootStrap
        partnerView={eventRouteDetails.isPartnerView}
      >
        <Router history={history}>
          <React.Fragment>
            <Route path={`${APP_CONFIG.reactBasePath + error.route}`} component={ErrorPage} />
            <Route exact path={`${APP_CONFIG.reactBasePath + homepage.route}`} component={AuthenticatedRoot} />
            <Route exact path={`${APP_CONFIG.reactBasePath + partnerView.route}`} component={AuthenticatedRoot} />
          </React.Fragment>
        </Router>
      </DataBootStrap>
    );
  }
  return '';
};

const ApplicationRouter = () => {
  if (window === window.parent) {
    return (
      <Provider store={eventRouteDetails.isEventRouteAndUserHashPresent
        || eventRouteDetails.isHostedRoutePresent
        || eventRouteDetails.isBusinessPopMailRoutePresent
        || eventRouteDetails.isAdaptiveMobilityExternalPresent
        ? unauthenticatedStore : authenticatedStore}
      >
        <AuthorableContent>
          {eventRouteDetails.isPartnerView ?
            <AppSecureAuthRedirect>
              <SSMRoutesSetup />
            </AppSecureAuthRedirect>
            :
            <AppCIPRedirect>
              {eventRouteDetails.isEventRouteAndUserHashPresent
                || eventRouteDetails.isHostedRoutePresent
                || eventRouteDetails.isBusinessPopMailRoutePresent
                || eventRouteDetails.isAdaptiveMobilityExternalPresent
                ? <VantageAndHostedMigrationRoutesSetup /> : <SSMRoutesSetup />}
            </AppCIPRedirect>
          }
        </AuthorableContent>
      </Provider>
    );
  }
  return '';
};


export default ApplicationRouter;
